<mobile-page-part>
	<div class="info-content">
		<small>[Activity Type Selector Goes Here]</small>
	</div>
</mobile-page-part>